import React, { useState, useEffect } from "react";



import { useNavigate, Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import db from "./Firebase";
import { storage } from './Firebase';
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import Moment from 'moment';
import { extendMoment } from 'moment-range';

function StudioReview() {

    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");


    useEffect(() => {
        db.collection("nv_studio_review").orderBy("date", "desc").onSnapshot((snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });

    }, []);

    // Step 3: Filter data based on search query and availability filter
    const filteredData = data.filter((record) => {
        return (
            record.data.phone.includes(searchQuery)
        );
    });



    const handleSearch = (e) => {
        setSearchQuery(e.target.value); // Step 3: Update search query state
    }


    return (
        <>
            <div class="p-2" style={{ paddingBottom: "5px", display: "flex", justifyContent: "space-between" }}>
                <Link to="/"><img src="/images/menubutton.png" class="menu-toggle" alt="Responsive image" style={{ height: "2rem" }} /></Link>

            </div>

            <div class="p-3">

                <div class="card-header pb-0 px-3">
                    <h6 class="mb-2">Studio Review Page - (Count : {data.length})</h6>
                </div>
                <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search by phone no..."
                    value={searchQuery}
                    onChange={handleSearch}
                />


                <div class="table-responsive fix-width scroll-inner">
                    <table class="table table-bordered table-hover">
                        <thead class="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Card Name</th>
                                <th>Rate Review</th>
                                <th>Type</th>
                                <th>Created Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData?.map(({ id, data }, index) => (
                                <>
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>{data.name}</td>
                                        <td>{data.phone}</td>
                                        <td>{data.card_name}</td>
                                        <td>{data.rate}</td>
                                        <td>{data.review}</td>
                                        <td>{moment(data.date.toDate().toISOString()).format("DD/MM/YY, h:mm a")}</td>
                                    </tr>
                                </>
                            ))}


                        </tbody>
                    </table>
                </div>
            </div>



        </>
    )
}

export default StudioReview